const tags = {
    data() {
        return {
            tags_tagList: [
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_Architecture.svg",
                    color: "#E876A8",
                    tag: "Architecture",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_cloud.svg",
                    color: "#F9E34D",
                    tag: "Cloud-DevOps",
                    name: "Cloud & DevOps"
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_data.svg",
                    color: "#6EA3EB",
                    tag: "DATA",
                    name: "Data"
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_AI.svg",
                    color: "#A3E8D6",
                    tag: "AI",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_JVM.svg",
                    color: "#BCE26E",
                    tag: "JVM",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_leadership.svg",
                    color: "#D39EF1",
                    tag: "Leadership-MGMT",
                    name: 'Leadership & MGMT',
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_quality_test.svg",
                    color: "#EF9644",
                    tag: "Quality-Test",
                    name: "Quality & Test",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_Security.svg",
                    color: "#E876A8",
                    tag: "Security",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_off_track.svg",
                    color: "#F9E34D",
                    tag: "OFF",
                    name: "OFF Track",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_Web.svg",
                    color: "#6EA3EB",
                    tag: "Web",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_Keynote.svg",
                    color: "#A3E8D6",
                    name: "Keynote",
                    tag: "Keynote",
                },
                {
                    icon: "https://res.cloudinary.com/oredev/image/upload/v1742518073/2025/Icons/icon_net.svg",
                    color: "#BCE26E",
                    tag: "NET",
                    name: ".Net",
                },
            ]
        };
    },
    // Due to Vue 2 and mixin merging into "this" in templates, tags_ prefix is set to methods
    methods: {
        tags_getOrderedTagList() {
            const desiredOrder = [
                'Architecture', 'NET', 'DATA', 'Cloud-DevOps', 'AI', 'JVM', 'Keynote',
                'Leadership-MGMT', 'OFF', 'Quality-Test', 'Security', 'Web'
            ];

            // Reorder based on desired order
            return desiredOrder.map(tagKey =>
                this.tags_tagList.find(t => t.tag === tagKey)
            ).filter(Boolean); // Remove any undefined entries
        },
        tags_activeBg(tag) {
            const activeTags = this.$route.query.tags;
            // Handle comma-separated query (tags=ai,ml,design)
            const tagArray = typeof activeTags === 'string'
                ? activeTags.split(',')
                : [];

            // Check if this tag is currently selected
            if (tagArray.includes(tag)) {
                const tagObj = this.tags_tagList.find(t => t.tag === tag);
                if (tagObj) {
                    return { backgroundColor: tagObj.color };
                }
            }
            return {}; // default: no style
        },
        tags_getColor(tag) {
            const tagObj = this.tags_tagList.find(t => t.tag === tag);
            if (tagObj) {
                return tagObj.color;
            } else {
                return "#abcdef";
            }
        },
        tags_getName(tag) {
            const tagObj = this.tags_tagList.find(t => t.tag === tag);
            if (!tagObj) return 'tagNotFound'
            else return tagObj.name ? tagObj.name : tagObj.tag;
        },
        tags_getIcon(tag) {
            const tagObj = this.tags_tagList.find(t => t.tag === tag);
            if (!tagObj) return 'tagNotFound'
            else return tagObj.icon;
        }
    }
}

export default tags;


// WEBPACK FOOTER //
// ./src/mixins/tags.js